import axios from "axios";
import { React, useState } from "react";
import ReactPlayer from "react-player";

import { Link } from "react-router-dom";

import Share from "../../Assets/Images/share.png";
import ShareB from "../../Assets/Images/ShareB.png";
import SharePost from "../../Screen/SharePost";
export default function LiveContent({ user }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({
    likes: 1,
    updated: false,
  });

  const [isShare, setIsShare] = useState(false);

  const [likerId, setLikerId] = useState();
  const [isLiked, setIsLiked] = useState();
  const [likeCount, setLikeCount] = useState();
  const [shareCount, setShareCount] = useState();

  function handleChange(data, postId) {
    const formData = new FormData();
    setLikerId(data);

    formData.append("showlike", JSON.stringify(data));

    axios.post(`/api/submit_react/${postId}`, formData).then((res) => {
      if (res.status === 200) {
      }
    });
  }

  return (
    <>
      <div className="container PostWidth align-items-center justify-content-center col-11 Enroll-Auditions">
        <div className="card PostCardBg ">
          <h2 className="accordion-header PostBack">
            <div className="d-flex justify-content-between">
              <div className="accordion-button-fx profile1-accordion-button PostBack  collapsed">
                <img
                  src={user.profilePicture}
                  className="PostImgHome"
                  alt="star-profile"
                />
                <span className="mx-2 text-warning text-light">
                  <Link
                    to={`/starprofile/${user.id}`}
                    className="link-starPorfile"
                  >
                    {user.username}
                  </Link>
                  <br></br>
                  <small className="category-size-chat">
                    {user.time}
                    {" | "}
                  </small>
                  <small className="category-size-chat">{user.date}</small>
                </span>
              </div>
            </div>
          </h2>
          <h5 className="my-2 Enroll-a Enroll-text text-justify ">New Video</h5>

          <div className="ViewPost ">
            <div className=" card  border-0 containerPost">
              <ReactPlayer
                url={user.video}
                className="Live-Video-x"
                playing={false}
                volume={1}
              />
            </div>

            <div className="ViewPost">
              <div className="d-flex justify-content-between PostGV">
                <div className="col-md-6">
                  <li className="like-post">
                    {likeCount === 0 ? null : (
                      <>
                        <i className="fas fa-heart heart mx-1 "></i>
                        <small className="profile-card-text">{likeCount}</small>
                      </>
                    )}
                  </li>
                </div>
                <div className="col-md-6">
                  <li className="share-post">
                    {shareCount === 0 ? null : (
                      <>
                        <img src={Share} alt="" width="15" /> &nbsp;
                        <small className="profile-card-text">
                          {shareCount} Shares
                        </small>
                      </>
                    )}
                  </li>
                </div>
              </div>
              <div className=" LikedBg px-4">
                <div className="di">
                  {isLiked ? (
                    <button
                      className="BtnD py-2 border-0"
                      // onClick={() => handleClick(post.id, 0)}
                    >
                      <i className="fas fa-heart mx-1 text-danger"></i>
                      <small className="Post-Title-home"> Loved </small>
                    </button>
                  ) : (
                    <button
                      className="BtnD py-2 border-0"
                      // onClick={() => handleClick(post.id, 1)}
                    >
                      <i className="fas fa-heart mx-1 text-light"></i>
                      <small className="Post-Title-home"> Love </small>
                    </button>
                  )}
                </div>
                <div className="di">
                  <button
                    className="BtnD py-2 border-0"
                    //  onClick={shareHandler}
                  >
                    <img src={ShareB} width="20" alt="" />
                    &nbsp;
                    <small className="Post-Title-home"> Share</small>
                  </button>
                  {isShare ? (
                    <div className="sharePostMainDiv">
                      <SharePost
                        // postId={post.id}
                        type="postshare"
                        // onMoveData={moveData}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
